<template>
<div>
    <button 
    v-if="identifier" 
    @click="handleAction()" 
    :disabled="loading || hasError || disableButton" 
    type="button" class="btn btn-secondary text-danger">
        {{loading ? 'Cargando...' : 'Despublicar avisos'}}
    </button>

    <div v-if="disableButton" class="alert alert-warning p-2">
        <i class="fa fa-warning mr-1"></i> Atención <br>
        Bloqueo de publicaciones aún se encuentra en proceso.
    </div>

</div>
</template>
<script>
import moment from 'moment';
import utils from '@/helpers/utils';
import sysMsgs from "@/helpers/system.message";
import inventoryServices from "@/services/inventory.services";

const COOKIE_NAME = "blocking-queue-starttime-";

export default {
    name: "InventoryButton",
    props:["identifier"],
    data() {
        return {
            hasError: false,
            loading: false,
            disableButton: false
        }
    },
    watch: {
        identifier: {
            deep: true,
            handler(data) {
                if (data) {
                    this.disableButton = utils.checkCookieExp(this.identifier);
                }
            }
        }
    },
    methods: {
        handleAction() {
            sysMsgs.getConfirm(`¿Está seguro de Despublicar los avisos?`, "warning", "Confirmar acción").then(result => {
                if(result.value) {
                    this.toggleStatus();
                }
            });
        },
        toggleStatus() {
            this.hasError = false;
            this.loading = true;
            inventoryServices.updateInventoryStatus(this.identifier).then(() => {
                this.loading = false;
                this.republishAdverts()
            }).catch(error => {
                console.log('Component: InventoryButton, FN: toggleStatus', error.message);
                sysMsgs.getMessage("Error al actualizar inventario.", "error");
                this.hasError = true;
                this.loading = false;
            })
        },
        republishAdverts() {
            this.hasError = false;
            this.loading = true;

            inventoryServices.updateInventoryStatus(this.identifier, true).then(() => {
                this.loading = false;
                this.disableButton = true;
                this.$parent.getListingCount()
                utils.setCookieExp(this.identifier)
                sysMsgs.getDialog("Esta acción puede demorar varios minutos en verse reflejada.", "info", "Operacion exitosa")
            }).catch(error => {
                console.log('Component: InventoryButton, FN: republishAdverts', error.message);
                sysMsgs.getMessage("Error al actualizar inventario.", "error");
                this.hasError = true;
                this.loading = false;
            })
        }

    }
}
</script>